import React from 'react'
import { Create } from 'react-admin'

import CompetitionsForm from './form'

export const CompetitionsCreate = (props) => (
  <Create {...props}>
    <CompetitionsForm isEdit={false} {...props} />
  </Create>
)

export default CompetitionsCreate
